import React, {Component} from 'react';
import { withRouter } from "react-router-dom";





class WhenAGuestCalls extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>When a Guest Calls </h2>

                <br/>
               

              
                
              <p className='text-primary'>When a guest calls, it will be be for one primary reasons:  Did you find my stuff?  </p>
               <br/>
                <h6>Step 1: </h6>
                <p className='text-info'> Ask room number or location where they last left the item </p>

                <br/><br/>
                <h6>Step 2:  Search in the lost &amp; Found </h6>
                <p className='text-info'>Click the "Lost &amp; Found" Link in the menu.  Enter search critera, like room number of 'lobby'. ( See Below Image) </p>
                <p className='text-primary'>The table will display everything that was found in the lobby.  Locate the item that matchs the guest's description and click the item. For example, 
                he or she claimed that they had lost their 
                watch with a black face and made by IWC.  Clicking on that record will display the lost item details: </p>

                <br/><br/>
                <div className="text-center">
                    <img className='text-center' style={{width:'80%', height:'80%'}} src='./images/lobbysearch.png' alt=''/> 
                </div>
            

                <br/><br/>
                 <h6>Lost &amp; Found Item Detail Screen:</h6>


                <div className="text-center">
                    <img className='text-center' style={{width:'80%', height:'80%'}} src='./images/lostitemwatch.png' alt=''/> 
                </div>

            <h6>Step 3:  Verify </h6>  
                <p className='text-info'>Ask the guest to describe any special markings or inscriptions.  Check "Internal Claim Challenge" field and question to verify.</p>
            
            <h6>Step 4:  Ship or Pickup </h6>  
            
            
            <p className='text-info'>If they verified the item and its a match, ask to either have the item shipped back or picked up in person.</p>
            
            <h6>Step 5:  Pickup </h6>  
            <p className='text-info'>Click "New Claim" button to add this guest's claim to the system. This is pop-up a new claim screen to gather guest information.</p>
            <div className="text-center">
                    <img className='text-center'  src='./images/newclaimbutton.png' alt=''/> 
            </div>
            <br/> <br/>

             <p className='text-info'>Enter the guest's first name, last name, phone / email and select "Will pickup" as the status.  Select the date of pickup. This will now show in the claims screen
             and the dashboard.  When the guestn picks up the item, locate this claim, and change the status to closed-picked up.</p>
            <div className="text-center">
                    <img className='text-center' style={{width:'500px', height:'900px%'}} src='./images/newclaimpopup.png' alt=''/> 5
            </div>


  
   <p className='text-info'>If they verified the item and its a match, ask to either have the item shipped back or picked up in person.</p>
 
              


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(WhenAGuestCalls);
